import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
    createRawMaterials,
    updateRawMaterials,
} from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";

export const EditRawMaterials = ({
    showModal,
    setShowModal,
    fetchRawmaterials,
    selectedRawmaterial,
    AddorEdit,
    setCurrentPage,
}) => {
    const { showLoader, hideLoader, UserItem, shopItem, warehouse, parentCompany } = useContext(WarehouseContext);

    const [formData, setFormData] = useState({
        title: "",
        title_num: "",
        title_text: "",
        qty: "",
        product_code: "",
        reorder_point: "",
        type: "0",
        created_by: UserItem?.user_id || "0",
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (selectedRawmaterial) {
            const rawTitle = selectedRawmaterial?.title || "";
            const isPackaging = selectedRawmaterial?.type?.toString() === "1";
            let titleNum = "";
            let titleText = rawTitle;

            if (isPackaging) {
                const match = rawTitle.match(/^(\d+)\s*(.*)$/);
                if (match) {
                    titleNum = match[1];
                    titleText = match[2];
                }
            }

            setFormData({
                title: rawTitle,
                title_num: titleNum,
                title_text: titleText,
                product_code: selectedRawmaterial?.product_code || "",
                reorder_point: selectedRawmaterial?.reorder_point || "",
                type: selectedRawmaterial?.type?.toString() || "0",
                created_by: UserItem?.user_id || "0",
            });
        } else {
            resetForm();
        }
    }, [selectedRawmaterial]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader();

        const validationErrors = {};
        if (formData.type === "1") {
            if (!formData.title_num) validationErrors.title_num = "Number is required.";
            if (!formData.title_text) validationErrors.title_text = "Title/Text is required.";
        } else {
            if (!formData.title) validationErrors.title = "Title is required.";
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            hideLoader();
            return;
        }

        try {
            // ✅ Build payload
            let finalTitle = formData.title;
            if (formData.type === "1") {
                finalTitle = `${formData.title_num || ""} ${formData.title_text || ""}`.trim();
            }

            const payload = {
                ...formData,
                title: finalTitle,
                warehouse_id: warehouse?.id || "",
                shop_id: shopItem?.shop_id || shopItem?.id || "",
                branch_id: parentCompany?.parent_company_id || parentCompany?.id || "",
            };

            // Remove temp fields
            delete payload.title_num;
            delete payload.title_text;

            if (AddorEdit) {
                await createRawMaterials(payload);
                toast.success("Raw Material added successfully");
            } else {
                await updateRawMaterials(selectedRawmaterial?.id, payload);
                toast.success("Raw Material updated successfully");
            }

            fetchRawmaterials();
            handleCancel();
        } catch (error) {
            console.error("Error saving Raw Material data:", error);
            toast.error(error?.response?.data?.message || "Error saving Raw Material");
        } finally {
            hideLoader();
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "title" || name === "title_text") {
            // Only alphabets, numbers, and spaces
            if (!/^[A-Za-z0-9\s]*$/.test(value)) return;
        }

        if (name === "title_num") {
            // Only numbers
            if (!/^[0-9]*$/.test(value)) return;
        }

        setFormData((prev) => {
            const updated = {
                ...prev,
                [name]: value,
            };

            if (name === "type") {
                if (value === "1") {
                    let titleNum = "";
                    let titleText = "";
                    const match = prev.title.match(/^(\d+)\s*(.*)$/);
                    if (match) {
                        titleNum = match[1];
                        titleText = match[2];
                    } else {
                        titleText = prev.title;
                    }
                    updated.title_num = titleNum;
                    updated.title_text = titleText;
                } else {
                    updated.title = `${prev.title_num || ""} ${prev.title_text || ""}`.trim();
                }
            }

            return updated;
        });

        setErrors((prev) => ({
            ...prev,
            [name]: "",
            ...(name === "type" ? { title: "", title_num: "", title_text: "" } : {}),
            ...(name === "title_num" ? { title_num: "" } : {}),
            ...(name === "title_text" ? { title_text: "" } : {}),
        }));
    };

    const resetForm = () => {
        setFormData({
            title: "",
            title_num: "",
            title_text: "",
            product_code: "",
            reorder_point: "",
            type: "0",
            created_by: UserItem?.user_id || "0",
        });
    };

    const handleCancel = () => {
        setShowModal(false);
        resetForm();
    };

    return (
        <>
            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block" }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                                    {selectedRawmaterial ? "Edit Raw Material" : "Add Raw Material"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => handleCancel()}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ fontFamily: "poppins" }}>
                                <form onSubmit={handleSubmit} className="row g-3">
                                    <div className="col-md-12">
                                        <label>Type</label>
                                        <select
                                            name="type"
                                            value={formData.type}
                                            onChange={handleChange}
                                            className="form-control"
                                        >
                                            <option value="0">Spices</option>
                                            <option value="1">Packaging material</option>
                                            <option value="2">Litre</option>
                                        </select>
                                    </div>
                                    {formData.type === "1" ? (
                                        <>
                                            <div className="col-md-6">
                                                <label>Number</label>
                                                <input
                                                    type="text"
                                                    name="title_num"
                                                    value={formData.title_num || ""}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    placeholder="e.g. 100"
                                                />
                                                {errors.title_num && (
                                                    <small className="text-danger">{errors.title_num}</small>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <label>Title</label>
                                                <input
                                                    type="text"
                                                    name="title_text"
                                                    value={formData.title_text || ""}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    placeholder="e.g. Gram cover"
                                                />
                                                {errors.title_text && (
                                                    <small className="text-danger">{errors.title_text}</small>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="col-md-12">
                                            <label>Title</label>
                                            <input
                                                type="text"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.title && (
                                                <small className="text-danger">{errors.title}</small>
                                            )}
                                        </div>
                                    )}
                                    <div className="col-md-12">
                                        <label>Reorder Point</label>
                                        <input
                                            type="Number"
                                            name="reorder_point"
                                            value={formData.reorder_point}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {errors.reorder_point && (
                                            <small className="text-danger">{errors.reorder_point}</small>
                                        )}
                                    </div>
                                    <div className="col-md-12">
                                        <label>Product Code</label>
                                        <input
                                            type="text"
                                            name="product_code"
                                            value={formData.product_code}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {errors.product_code && (
                                            <small className="text-danger">{errors.product_code}</small>
                                        )}
                                    </div>

                                    {/* You can keep status if required */}
                                    {/* <div className="col-md-12">
                                        <label>Status</label>
                                        <select
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}
                                            className="form-control"
                                        >
                                            <option value="">Select Status</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div> */}

                                    <div className="col-12 text-end">
                                        <button type="submit" className="btn btn-success">
                                            {selectedRawmaterial ? "Update Raw Material" : "Add Raw Material"}
                                        </button>
                                        &nbsp;&nbsp;
                                        <button
                                            type="button"
                                            className="btn btn-secondary ml-2"
                                            onClick={() => handleCancel()}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
